import { Encodings, Font } from "@pdf-lib/standard-fonts";
import type { IFontNames } from "@pdf-lib/standard-fonts";

/** Rejects clipped appearances before changing a PDF's text annotation. */
export function assertPdfTextFits(
  text: string,
  width: number,
  height: number,
  fontSize: number,
  fontFamily: IFontNames,
): void {
  const font = Font.load(fontFamily);
  const availableWidth = width - 2;
  const measure = (value: string) => [...value].reduce((sum, character) => {
    const glyph = Encodings.WinAnsi.encodeUnicodeCodePoint(character.codePointAt(0)!);
    return sum + (font.getWidthOfGlyph(glyph.name) || 0) * fontSize / 1000;
  }, 0) * 1.03;
  let lines = 0;
  for (const paragraph of text.replace(/\r\n?/g, "\n").replace(/\t/g, "    ").split("\n")) {
    lines++;
    let lineWidth = 0;
    let spaceWidth = 0;
    for (const token of paragraph.match(/\S+| +/g) || []) {
      const tokenWidth = measure(token);
      if (/^ +$/.test(token)) {
        spaceWidth += tokenWidth;
      } else {
        if (tokenWidth > availableWidth)
          throw new Error(`Text does not fit this box. No changes were applied. Increase its width to at least ${Math.ceil(tokenWidth + 2)} points, or use a smaller font.`);
        if (lineWidth && lineWidth + spaceWidth + tokenWidth > availableWidth) {
          lines++;
          lineWidth = tokenWidth;
        } else {
          lineWidth += (lineWidth ? spaceWidth : 0) + tokenWidth;
        }
        spaceWidth = 0;
      }
    }
  }
  const requiredHeight = lines * fontSize * 1.18 + 1.5;
  if (height < requiredHeight)
    throw new Error(`Text would be clipped in this box. No changes were applied. Increase its height to at least ${Math.ceil(requiredHeight)} points, widen the box, or use a smaller font.`);
}
